import { render } from "./ScanButton.vue?vue&type=template&id=da37563c"
import script from "./ScanButton.vue?vue&type=script&lang=ts"
export * from "./ScanButton.vue?vue&type=script&lang=ts"
script.render = render

export default script